import { Navigate } from 'react-router-dom';

/**
 * Since registration and backend authentication have been removed in favor
 * of direct WhatsApp Business communication, protected routes redirect to the
 * home / services page gracefully.
 */
export function ProtectedRoute({ children }) {
  const token = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null;
  
  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
}
